import { render } from "./HistoryTable.vue?vue&type=template&id=3d5611d2&scoped=true"
import script from "./HistoryTable.vue?vue&type=script&lang=js"
export * from "./HistoryTable.vue?vue&type=script&lang=js"

import "./HistoryTable.vue?vue&type=style&index=0&id=3d5611d2&lang=scss&scoped=true"

import exportComponent from "/Users/mapat/Projects/orange-hrm/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d5611d2"]])

export default __exports__